export default __webpack_public_path__ + "static/media/Q22024.f88921d8.pdf";